export default __webpack_public_path__ + "static/media/pending.fe6f9918.png";